import { Component, Input } from '@angular/core';
import { LoyaltyTier } from '@fgb/core';

@Component({
  selector: 'fgb-tier-level-progress',
  templateUrl: './tier-level-progress.component.html',
  styleUrl: './tier-level-progress.component.scss',
})
export class TierLevelProgressComponent {
  @Input() selectedIndex: number;
  @Input() tier: LoyaltyTier;
  @Input() tierName: string;
  @Input() isLast: boolean = false;
  @Input() index: number;
  tiers = [{ Name: 'PRO' }, { Name: 'ALL_STAR' }, { Name: 'MVP' }, { Name: 'LEGEND' }];

  isSelected(index: number): boolean {
    if (!this.tierName) return false;

    return this.selectedIndex !== -1 && index <= this.selectedIndex;
  }
}
